(function() {
    'use strict';
    
a3_cabin_reports.controller('CrewExpiriesCtrl',CrewExpiriesCtrl)

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name CrewExpiriesCtrl
    * @description 
    *   Set/Get the crew expiries
    * @ngInject
    */
function CrewExpiriesCtrl($scope, ExpiriesFactory, AirlineInfoFactory){
    ExpiriesFactory.getAllExpiriesFromStorage().then(function (allExpiries) {
        $scope.allExpiries = (allExpiries || []).sort(function(a, b) {
            return new Date(a.ExpiryDate) - new Date(b.ExpiryDate);
        });
    });

        $scope.getHighlight = function(expiryDate) {
        //    var today = new Date('2016,06,01');
           var today = new Date();
           var expDate = new Date(expiryDate);
           var diffDays = Math.ceil((expDate.getTime() - today.getTime()) / (1000 * 60 * 60 *24));

           if (diffDays < 30){
            return '#D43F3A';
           } else if (diffDays < 90) {
            return '#FFaB5E';
           } 
        }

        $scope.isNeverExpiry = function(date) {
            return date && new Date(date).getFullYear() === 9999;
        };

        $scope.crewAirlineInfos = AirlineInfoFactory.getCrewAirlineInfos();
	}

})();